import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from '../../../services/theme.service';
import { JwtAuthService } from '../../../services/auth/jwt-auth.service';

@Component({
    selector: 'app-radiology-layout',
    templateUrl: './radiology-layout.template.html',
    standalone: false
})
export class RadiologyLayoutComponent implements OnInit {

  constructor(
    public translate: TranslateService,
    public themeService: ThemeService,
    private jwtAuth: JwtAuthService,
  ) {
    // Translator init
    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
  }

  ngOnInit() {
  }

}